// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"cdc807a3","227":"8f6ef29a","243":"0f1c9d5d","361":"8a2f6cf0","636":"11af922b","898":"7d3f21e1","900":"0b8bce4f"}[chunkId] + ".chunk.js";
};